import Bill from './bill';
import MasterData from './config/master-data';
import Magento from './api/magento';
import Config from './config/index';
import Notification from './notification';
import Lang from './lang';
import LoadAndSave from './load-and-save';
import Template from './template';
import Spinner from "./spinner";

Template.add('api.postBuyRedirect', Config.api.postBuyRedirect);

function getUrl(url) {
    return Config.api.magento + url;
}

function onBuy() {
    let bill = Bill.get();
    if (!bill) return;

    Spinner.show();

    const onErr = (err) => {
        Spinner.hide();
        Notification.show(Lang.get('buy.error'), 'error');
        console.error(err);
    };

    LoadAndSave.save(false).then((data) => {
        Magento._query(getUrl('/guest-carts'), {method: 'post'}).then((cartId) => {
            let url = getUrl(`/guest-carts/${cartId}/items`);
            let promises = [];

            Object.keys(bill).forEach((id) => {
                let qty = bill[id];
                let product = MasterData.products[id];
                if (!product) return;

                promises.push(
                    Magento._query(url, {
                        method: 'post',
                        data: JSON.stringify({
                            "cartItem": {
                                "sku": product.sku,
                                "qty": qty,
                                "quoteId": cartId
                            }
                        })
                    }).catch(console.error)
                );
            });


            // add version as cartItem
            promises.push(
                Magento._query(url, {
                    method: 'post',
                    data: JSON.stringify(getVersionCartItem(cartId, data.base_id, data.version))
                }).catch((err) => console.error('VERSION ITEM NOT BOUGHT', err)));

            Promise.all(promises).then((data) => {
                let quoteId = data && data.length ? data[0].quote_id : 0;
                Notification.show(Lang.get('buy.success'), 'success');
                let url = Template.fill('api.postBuyRedirect', {cartId: btoa(quoteId)});
                console.log('URL', data, quoteId, url);
                window.location = url;
            }).catch(onErr);
        });
    }).catch(onErr);
}

function getVersionCartItem(quoteId, modelId, modelVersion) {
    return {
        "cartItem": {
            sku: "config-kratzbaum",
            qty: 1,
            quoteId: quoteId,
            product_option: {
                extension_attributes: {
                    custom_options: [
                        {
                            option_id: 591,
                            option_value: modelId
                        },
                        {
                            option_id: 592,
                            option_value: modelVersion
                        },
                        {
                            option_id: 593,
                            option_value: Config.api.designer + "/" + modelId + "/" + modelVersion
                        }
                    ]
                }
            }
        }
    }
}

$(() => {
    $('.js--buy').on('click', onBuy);
});
